/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="70.86" height="93.74" viewBox="0 0 70.86 93.74" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M77.33,104h5.23a1,1,0,0,0,1-1,.76.76,0,0,0,0-.21l-3-13a1.11,1.11,0,0,1,0-.19.89.89,0,0,1,.41-.75,6.65,6.65,0,1,0-7,0,.87.87,0,0,1,.41.75,1.11,1.11,0,0,1,0,.19l-3,13a1.49,1.49,0,0,0,0,.21,1,1,0,0,0,1,1h5Z" transform="translate(-42 -30.5)" fill="#ffb81c" fillRule="evenodd"/><path d="M86.69,30.5A10.46,10.46,0,0,1,97.14,40.63v17a1.24,1.24,0,0,1-1.25,1.25,1.26,1.26,0,0,1-1.25-1.12V40.91A8,8,0,0,0,86.94,33H68.17a8,8,0,0,0-8,7.67v17a1.25,1.25,0,0,1-2.49.13V40.91A10.47,10.47,0,0,1,67.89,30.5h18.8Z" transform="translate(-42 -30.5)" fill="#0e497b"/><path d="M108.38,56.42H46.48A4.49,4.49,0,0,0,42,60.9v58.85a4.5,4.5,0,0,0,4.48,4.49h61.9a4.49,4.49,0,0,0,4.48-4.49V60.9A4.49,4.49,0,0,0,108.38,56.42Zm-61.9,2.5h61.9a2,2,0,0,1,2,2v58.85a2,2,0,0,1-2,2H46.48a2,2,0,0,1-2-2V60.9A2,2,0,0,1,46.48,58.92Z" transform="translate(-42 -30.5)" fill="#0e497b"/>
      </svg>

    );
  }
}

Icon.displayName = 'PadlockEngagedIcon';

export default Icon;
